export class JobNormalWworkPermitSignModel {
    id?: string | null = null;
    date?: string | null = null;
    time?: string | null = null;
    isSigned?: boolean | null = null;
    uniqueKey: string | null = null;
    jobNormalWorkPermitId: string | null = null;
    signedByUserId: string | null = null;

    linkedToSignId?: string | null = null;

    created?: string | null = null;

    constructor(data?: Partial<JobNormalWworkPermitSignModel>) {
        Object.assign(this, data);
    }
}
